"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CheckboxStyle = {
    baseStyle: {
        control: {
            borderColor: 'gray.600',
            _hover: {
                borderColor: 'purple.400',
            },
            _focus: {
                borderColor: 'purple.400',
            },
            _disabled: {
                borderColor: 'gray.300',
                background: 'white',
                _hover: {
                    borderColor: 'gray.300',
                },
            },
            _checked: {
                background: 'purple.400',
                borderColor: 'purple.400',
                _hover: {
                    background: 'purple.400',
                    borderColor: 'purple.400',
                },
                _focus: {
                    background: 'purple.400',
                    borderColor: 'purple.400',
                },
            },
            _invalid: {
                borderColor: 'red.400',
                _hover: {
                    borderColor: 'purple.400',
                },
                _focus: {
                    borderColor: 'purple.400',
                },
                _checked: {
                    borderColor: 'purple.400',
                },
            },
            marginTop: '0.3rem',
        },
        label: {},
        display: 'flex',
        alignItems: 'flex-start',
    },
};
exports.default = CheckboxStyle;
